import { Util } from "@xt/xtbase";
import generateFlatMethods from "./method";

// swagger 文档： https://swagger-ui.hmswork.space/cosmos-activity-impl/webjars/swagger-ui/index.html // v2

const { getOrigin } = Util;
const baseUrl = getOrigin("www") + "/acapi";

const {
  get,
  put,
  post,
  del,
} = generateFlatMethods(baseUrl);

const querystring = (params, prefix = true) => 
  Object.entries(params)
    .reduce((result, [key, value]) => {
      if (result) {
        result += '&';
      } else if (prefix) {
        result += '?';
      }

      return result += `${key}=${value}`;
    },
    '',
  );

const factory = (method, url) => (
  data,
  {
    urlAppend = false,
    ...config
  } = {},
) => {
  let params = data;
  let realUrl = url;
  if (urlAppend) {
    realUrl = `${url}${querystring(data)}`;
    params = null;
  }
  
  return method(realUrl, params, config);
};

export const getActivityInfo = factory(                 
  get,
  '/public/anniversary/activity',
);

export const getDrawList = factory(
  get,
  '/public/anniversary/draw/list',
);

export const getSignList = factory(
  get,
  '/anniversary/sign/list',
);

export const getTaskInfo = factory(
  get,
  '/anniversary/task',
);

export const getCanDuihuanAwardList = factory(
  get,
  '/public/anniversary/redeem/prize',
);

export const getDuihuanRecordList = factory(
  get,
  '/anniversary/redeem/record',
);

export const getDrawNumber = factory(
  get,
  '/anniversary/draw/number',
);

export const getDrawRecordList = factory(
  get,
  '/anniversary/draw/record',
);

export const getMyPoints = factory(
  get,
  '/anniversary/integral',
);

export const getMyPointDetails = factory(
  get,
  '/anniversary/integral/detail',
);

export const toSign = factory(
  post,
  '/anniversary/sign',
);

export const toLottery =factory(
  post,
  '/anniversary/draw',
);

export const toDuihuan = factory(
  post,
  '/anniversary/redeem',
);

export const putAccess = factory(
  put,
  '/public/anniversary/access',
);

export const getTotalPoints =factory(
  get,
  '/anniversary/total-integral',
);
